import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/images/2fa-picture.jpg'


const _hoisted_1 = { class: "container login sm-pdt-100 justify-content-center" }
const _hoisted_2 = { class: "w-100 d-flex justify-content-center align-items-center gap-20" }
const _hoisted_3 = { class: "w-100 d-flex flex-column justify-content-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "mb-20"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Reset Password", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "To ensure your account's security, please update your password to meet our new platform's enhanced security standards. Legacy passwords are no longer supported. Your new password must include a mix of letters, numbers, and special characters for better protection.", -1)
const _hoisted_8 = {
  key: 0,
  class: "text-danger pdl-15"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", null, "2 Factor Authentication", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "radioGroup" }, "We will send a code to your preferred method", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fs-sm text-dark-grey" }, "Please use a personal mobile phone number or email that you have sole control over for your 2FA. We will record your entry and you will need to access this to retrieve your authentication code whenever you login. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "pdt-10" }, "Preferred Method", -1)
const _hoisted_13 = { class: "radio-buttons d-flex mt-15" }
const _hoisted_14 = { class: "d-flex gap-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "participant" }, "Phone number", -1)
const _hoisted_16 = { class: "d-flex gap-2 pdl-30" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "local" }, "Email Address", -1)
const _hoisted_18 = {
  key: 1,
  class: "text-danger pdl-15"
}
const _hoisted_19 = {
  key: 2,
  class: "w-100 mt-3"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Phone Number", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", { class: "info_card info_card__danger mt-10" }, "By selecting the Phone Number option, providing us your mobile phone number, and clicking “Send Code,” you hereby consent to receive a verification message by text to the mobile phone number provided to register, as well as any time you wish to log in in order to verify your identity.", -1)
const _hoisted_22 = {
  key: 3,
  class: "w-100 mt-3"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Email Address", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("small", { class: "info_card info_card__danger mt-10" }, "By selecting the Email Address option, providing us your email address, and clicking “Send Code,” you hereby consent to receive a verification message by email to the email address provided to register, as well as any time you wish to log in in order to verify your identity.", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-4 mt-4 ms-md-0 ms-auto" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Send Code")
], -1)
const _hoisted_26 = {
  key: 4,
  class: "text-danger mt-2"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", null, "Enter Verification Code", -1)
const _hoisted_29 = { class: "form-group d-flex flex-column gap-4 mb-4" }
const _hoisted_30 = { for: "code" }
const _hoisted_31 = { class: "d-flex gap-4 mt-4" }
const _hoisted_32 = { class: "mt-3" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "text-danger mt-2"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 hide-mobile" }, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"max-width":"100%","max-height":"90vh"},
    class: "rounded img-fluid",
    src: _imports_0,
    alt: "2FA Image"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicHeader = _resolveComponent("PublicHeader")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_PhoneField = _resolveComponent("PhoneField")!
  const _component_VerificationCodeInput = _resolveComponent("VerificationCodeInput")!
  const _component_PublicFooter = _resolveComponent("PublicFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PublicHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!$setup.showVerification)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("form", {
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitForm && $setup.submitForm(...args)), ["prevent"])),
                  class: "gap-10 form-two-factor-setup"
                }, [
                  ($setup.legacy == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _hoisted_7,
                        _createVNode(_component_TextInput, {
                          type: "password",
                          name: "mixed",
                          placeholder: "Password",
                          modelValue: $setup.password,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event)),
                          class: "mt-20"
                        }, null, 8, ["modelValue"]),
                        ($setup.errors.password)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errors.password, (err, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(err), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_TextInput, {
                          type: "password",
                          name: "mixed",
                          placeholder: "Password Confirmation",
                          modelValue: $setup.passwordConfirmation,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.passwordConfirmation) = $event)),
                          class: "mt-20"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "participant",
                        name: "method",
                        value: "P",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.method) = $event))
                      }, null, 512), [
                        [_vModelRadio, $setup.method]
                      ]),
                      _hoisted_15
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "local",
                        name: "method",
                        value: "E",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.method) = $event))
                      }, null, 512), [
                        [_vModelRadio, $setup.method]
                      ]),
                      _hoisted_17
                    ])
                  ]),
                  ($setup.errors.method)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errors.method, (err, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(err), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.method === 'P')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_PhoneField, {
                          type: "tel",
                          label: "Verified Phone number",
                          placeholder: "x (xxx) xxx-xxxx",
                          max: 17,
                          modelValue: $setup.phone,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.phone) = $event))
                        }, null, 8, ["modelValue"]),
                        _hoisted_21
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.method === 'E')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_TextInput, {
                          type: "email",
                          modelValue: $setup.email,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.email) = $event)),
                          label: "Verified Email Address",
                          placeholder: "Enter Email",
                          error: $setup.generalErrors,
                          max: 100
                        }, null, 8, ["modelValue", "error"]),
                        _hoisted_24
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_25,
                  ($setup.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.errorMessage), 1))
                    : _createCommentVNode("", true)
                ], 32)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, "Enter the code sent to your " + _toDisplayString($setup.method === 'P' ? 'phone number' : 'email address'), 1),
                  _createVNode(_component_VerificationCodeInput, {
                    modelValue: $setup.code,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.code) = $event)),
                    onKeyup: _withKeys($setup.verifyCode, ["enter"])
                  }, null, 8, ["modelValue", "onKeyup"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.backToSetup && $setup.backToSetup(...args))),
                      class: "btn btn-secondary"
                    }, "Go Back / Change 2FA " + _toDisplayString($setup.method === 'P' ? 'Number' :  'Email'), 1),
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.verifyCode && $setup.verifyCode(...args))),
                      class: "btn btn-primary"
                    }, "Verify Code")
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitForm && $setup.submitForm(...args)), ["prevent"]))
                    }, "Resend Code"),
                    ($setup.timer > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, " (" + _toDisplayString($setup.timer) + " seconds remaining)", 1))
                      : _createCommentVNode("", true)
                  ]),
                  ($setup.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString($setup.errorMessage), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
        ]),
        _hoisted_35
      ])
    ]),
    _createVNode(_component_PublicFooter)
  ], 64))
}